export default {
  path: 'trip-configuration',
  name: 'TripConfiguration',
  component: () => import(/* webpackChunkName: "base" */ '../views/TripConfiguration.vue')
}
